import { useEffect, useLayoutEffect, useRef } from 'react';

export function useCatalogueScroll(showingDetail: boolean, search: string, ready: boolean) {
  const list = useRef<HTMLUListElement>(null);
  const position = useRef({ page: 0, list: 0 });
  const previousSearch = useRef(search);
  const restore = useRef(false);
  const wasDetail = useRef(showingDetail);
  const selected = useRef<HTMLButtonElement | null>(null);

  useLayoutEffect(() => {
    if (previousSearch.current !== search) {
      position.current = { page: 0, list: 0 };
      selected.current = null;
      previousSearch.current = search;
    }
    if (wasDetail.current && !showingDetail) restore.current = true;
    wasDetail.current = showingDetail;
    if (!showingDetail && ready && restore.current) {
      restore.current = false;
      if (list.current) list.current.scrollTop = position.current.list;
      window.scrollTo({ top: position.current.page, behavior: 'instant' });
      if (selected.current?.isConnected) selected.current.focus({ preventScroll: true });
    }
  }, [showingDetail, search, ready]);

  useEffect(() => {
    if (showingDetail) return;
    const element = list.current;
    const remember = () => {
      position.current = { page: window.scrollY, list: element?.scrollTop ?? 0 };
    };
    window.addEventListener('scroll', remember, { passive: true });
    element?.addEventListener('scroll', remember, { passive: true });
    return () => {
      window.removeEventListener('scroll', remember);
      element?.removeEventListener('scroll', remember);
    };
  }, [showingDetail]);

  return { list, selected };
}
